"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trendsReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var TrendsAction_1 = require("@/pages/common/actions/TrendsAction");
var TrendsState_init_1 = require("@/pages/common/states/TrendsState.init");
exports.trendsReducer = function (state, action) {
    if (state === void 0) { state = TrendsState_init_1.defaultTrendsState; }
    switch (action.type) {
        case typesafe_actions_1.getType(TrendsAction_1.default.onChartGroupUpdated): {
            return __assign(__assign({}, state), { newChartGroups: action.payload });
        }
        case typesafe_actions_1.getType(TrendsAction_1.default.setChartType): {
            return __assign(__assign({}, state), { newChartGroups: state.newChartGroups.map(function (r) {
                    if (r.type === action.payload) {
                        r.active = true;
                        r.charts = r.charts.map(function (rx, j) {
                            if (j === r.charts.length - 2) {
                                rx.active = true;
                            }
                            else {
                                rx.active = false;
                            }
                            return rx;
                        });
                    }
                    else {
                        r.active = false;
                        r.charts = r.charts.map(function (rx, j) {
                            rx.active = false;
                            return rx;
                        });
                    }
                    return r;
                }) });
        }
        case typesafe_actions_1.getType(TrendsAction_1.default.setChartIndex): {
            var currentChartType_1 = state.newChartGroups.findIndex(function (r) { return r.active; });
            return __assign(__assign({}, state), { newChartGroups: state.newChartGroups.map(function (r, i) {
                    if (i === currentChartType_1) {
                        r.charts = r.charts.map(function (rx, j) {
                            if (j === action.payload) {
                                rx.active = true;
                            }
                            else {
                                rx.active = false;
                            }
                            return rx;
                        });
                    }
                    return r;
                }) });
        }
        case typesafe_actions_1.getType(TrendsAction_1.default.setChartPopup): {
            return __assign(__assign({}, state), { chartPopup: action.payload });
        }
        case typesafe_actions_1.getType(TrendsAction_1.default.onCustomFromChange): {
            return __assign(__assign({}, state), { customFrom: action.payload });
        }
        case typesafe_actions_1.getType(TrendsAction_1.default.onCustomToChange): {
            return __assign(__assign({}, state), { customTo: action.payload });
        }
        case typesafe_actions_1.getType(TrendsAction_1.default.onCustomFromToChange): {
            var _a = action.payload, from = _a.from, to = _a.to;
            return __assign(__assign({}, state), { customFrom: from, customTo: to });
        }
        case typesafe_actions_1.getType(TrendsAction_1.default.setSelectTypeActive): {
            return __assign(__assign({}, state), { isSelectTypeActive: action.payload });
        }
        case typesafe_actions_1.getType(TrendsAction_1.default.setSelectDurationActive): {
            return __assign(__assign({}, state), { isSelectDurationActive: action.payload });
        }
        default: {
            return state;
        }
    }
};
